
export const getAttributeInstances = (installation, attribute) =>
    installation.data
    && installation.data[attribute]
    && installation.data[attribute].instances

export const getAttributeInstanceValue = (installation, attribute, key) =>
    getAttributeInstances(installation, attribute)
    && installation.data[attribute].instances[key]

export const applyMinMaxFilter = (minValue, maxValue , output, attribute) => {
    const min = minValue !== "" ? minValue : false;
    const max = maxValue !== "" ? maxValue : false;

    if (!max && !min) {
        return output;
    }
    return output.filter(installation => {installation.data
        if (
            !installation.data ||
            !installation.data[attribute] ||
            !installation.data[attribute].rawValue || // needs to contain a value
            installation.data[attribute].rawValue === null ||
            installation.data[attribute].rawValue === undefined
        ) {
            return false;
        }
        if(min && !max){ // just Min
            return installation.data[attribute].rawValue >= parseFloat(min)
        }
        if (max && !min){ // just Max
            return installation.data[attribute].rawValue <= parseFloat(max)
        }
        if (max && min){ // min and max
            return installation.data[attribute].rawValue <= parseFloat(max)
                && installation.data[attribute].rawValue >= parseFloat(min)
        }
    })
}

export const applyMinMaxFilterPositives = (min, max , output, attribute) => {
    if (!max && !min) {
        return output;
    }
    return output.filter(installation => {installation.data
        if(
            !installation.data ||
            !installation.data[attribute] ||
            !installation.data[attribute].rawValue || // needs to contain a value
            installation.data[attribute].rawValue === null ||
            installation.data[attribute].rawValue === undefined
        ) {
            return false;
        }
        if(installation.data[attribute].rawValue <= 0) { // needs to be positive
            return false;
        }
        if(min && !max){ // just Min
            return installation.data[attribute].rawValue >= parseFloat(min)
        }
        if (max && !min){ // just Max
            return installation.data[attribute].rawValue <= parseFloat(max)
        }
        if (max && min){ // min and max
            return installation.data[attribute].rawValue <= parseFloat(max)
                && installation.data[attribute].rawValue >= parseFloat(min)
        }
    })
}
